<template>
  <div>

    <!--  顶部  -->
    <el-row class="top_style1">
      <el-col :span="12" class="logo-container">
        <div class="logo">
          <img src="https://img.moliaos.com/v/logo.png" width="50px" /> 陌撩漂流瓶
        </div>
      </el-col>
      <el-col :span="12" class="nav-container">
        <a class="nav-link active">首页</a>
        <a class="nav-link">关于我们</a>
      </el-col>
    </el-row>

    <!-- 主视觉区域 -->
    <div class="hero-section">
      <div class="hero-bg"></div>
      <div class="hero-particles"></div>
      <div class="hero-content">
        <h1 class="hero-title">遇见，是最美的意外</h1>
        <p class="hero-subtitle">让陌生的彼此，慢慢聊出专属默契</p>
        <el-image :src="require('@/assets/img/slider1.png')" class="hero-image"></el-image>

        <div class="download-buttons">
          <el-button class="download-btn android-btn">
            <el-image :src="require('@/assets/img/AndroidLog.png')"
              style="height: 20px; width: 20px;margin: -3px 10px -3px 0;"></el-image>
            安卓下载
          </el-button>
          <el-button class="download-btn ios-btn" disabled>
            <el-image :src="require('@/assets/img/IOSLog.png')"
              style="height: 20px; width: 20px;margin: -3px 10px -3px 0;"></el-image>
            苹果下载
          </el-button>
        </div>

        <!-- 数据统计 -->
        <div class="stats-section">
          <div class="stat-item">
            <div class="stat-number">100万+</div>
            <div class="stat-label">用户信赖</div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <div class="stat-number">50万+</div>
            <div class="stat-label">成功匹配</div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <div class="stat-number">98%</div>
            <div class="stat-label">用户好评</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 功能特点区域 -->
    <div class="features-section">
      <div class="section-header">
        <h2 class="section-title">为什么选择我们</h2>
        <p class="section-subtitle">真实、走心、有温度的社交体验</p>
      </div>
      <div class="features-container">
        <el-row :gutter="30">
          <el-col :span="6" class="feature-item">
            <div class="feature-icon">💎</div>
            <h3 class="feature-title">真实用户</h3>
            <p class="feature-desc">严格审核机制，确保每位用户都是真实存在</p>
            <el-image :src="require('@/assets/img/main/1.png')" fit="contain" class="feature-image"></el-image>
          </el-col>
          <el-col :span="6" class="feature-item">
            <div class="feature-icon">💫</div>
            <h3 class="feature-title">智能匹配</h3>
            <p class="feature-desc">AI算法帮你找到志趣相投的那个人</p>
            <el-image :src="require('@/assets/img/main/2.png')" fit="contain" class="feature-image"></el-image>
          </el-col>
          <el-col :span="6" class="feature-item">
            <div class="feature-icon">🔒</div>
            <h3 class="feature-title">隐私保护</h3>
            <p class="feature-desc">多重隐私保护机制，让你安心交友</p>
            <el-image :src="require('@/assets/img/main/3.png')" fit="contain" class="feature-image"></el-image>
          </el-col>
          <el-col :span="6" class="feature-item">
            <div class="feature-icon">💝</div>
            <h3 class="feature-title">走心交流</h3>
            <p class="feature-desc">抛开门当户对，回归最纯粹的情感交流</p>
            <el-image :src="require('@/assets/img/main/4.png')" fit="contain" class="feature-image"></el-image>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 用户评价区域 -->
    <div class="testimonials-section">
      <div class="section-header">
        <h2 class="section-title">他们都在这里找到了缘分</h2>
        <p class="section-subtitle">真实用户故事，源自内心的声音</p>
      </div>
      <div class="testimonials-container">
        <el-row :gutter="30">
          <el-col :span="8">
            <div class="testimonial-card">
              <div class="testimonial-avatar">👩</div>
              <div class="testimonial-name">小美</div>
              <div class="testimonial-location">上海 · 25岁</div>
              <p class="testimonial-text">"没想到真的能遇到那个他，感谢陌撩让我告别单身！"</p>
              <div class="testimonial-rating">⭐⭐⭐⭐⭐</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="testimonial-card">
              <div class="testimonial-avatar">👨</div>
              <div class="testimonial-name">阿杰</div>
              <div class="testimonial-location">北京 · 28岁</div>
              <p class="testimonial-text">"这里的用户都很真诚，终于找到了可以聊天的人。"</p>
              <div class="testimonial-rating">⭐⭐⭐⭐⭐</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="testimonial-card">
              <div class="testimonial-avatar">👩</div>
              <div class="testimonial-name">雨晴</div>
              <div class="testimonial-location">广州 · 26岁</div>
              <p class="testimonial-text">"陌撩让我相信，网络也能遇到真爱。"</p>
              <div class="testimonial-rating">⭐⭐⭐⭐⭐</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 底部CTA区域 -->
    <div class="cta-section">
      <h2 class="cta-title">准备好开启你的缘分之旅了吗？</h2>
      <p class="cta-subtitle">立即下载，和千万用户一起发现专属默契</p>
      <div class="cta-buttons">
        <el-button class="download-btn android-btn">
          <el-image :src="require('@/assets/img/AndroidLog.png')"
            style="height: 20px; width: 20px;margin: -3px 10px -3px 0;"></el-image>
          安卓下载
        </el-button>
        <el-button class="download-btn ios-btn" disabled>
          <el-image :src="require('@/assets/img/IOSLog.png')"
            style="height: 20px; width: 20px;margin: -3px 10px -3px 0;"></el-image>
          苹果下载
        </el-button>
      </div>
    </div>

    <div class="footer">
      <div class="footer-content">
        睢宁陌撩信息科技有限公司 <a href="https://beian.miit.gov.cn/" class="footer-link">备案号:苏ICP备2023024575号-1</a>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {
  }
}
</script>
<style>
/* 顶部导航栏 */
.top_style1 {
  height: 80px;
  width: 100%;
  background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%);
  padding: 0 10%;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 20px rgba(255, 154, 158, 0.3);
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo {
  font-size: 28px;
  font-weight: bold;
  color: #ffffff;
  letter-spacing: 2px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
}

.logo img {
  border-radius: 50%;
  margin-right: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.nav-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.nav-link {
  color: #ffffff;
  margin-left: 40px;
  font-size: 16px;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link:hover {
  color: #fff5f5;
  transform: translateY(-2px);
}

.nav-link.active {
  font-weight: bold;
}

.nav-link.active::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #ffffff;
  border-radius: 1px;
}

/* 主视觉区域 */
.hero-section {
  min-height: 700px;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #ff9a9e 0%, #fad0c4 50%, #fecfef 100%);
  z-index: 0;
}

.hero-particles {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="heart" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse"><path d="M10 5 L12 2 L14 5 L12 8 Z" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23heart)"/></svg>');
  opacity: 0.5;
  z-index: 1;
}

.hero-content {
  text-align: center;
  position: relative;
  z-index: 2;
  padding: 60px 20px;
}

.hero-title {
  font-size: 56px;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 20px;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  animation: fadeInDown 1s ease-out;
}

.hero-subtitle {
  font-size: 22px;
  color: #ffffff;
  margin-bottom: 40px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: fadeInUp 1s ease-out 0.3s both;
}

.hero-image {
  max-width: 800px;
  margin: 0 auto 40px;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  animation: fadeIn 1s ease-out 0.6s both;
}

/* 下载按钮 */
.download-buttons {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.download-btn {
  padding: 14px 35px;
  font-size: 16px;
  border-radius: 50px;
  margin: 0 15px;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  animation: fadeInUp 1s ease-out 0.9s both;
}

.download-btn:hover:not(:disabled) {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.android-btn {
  background: linear-gradient(135deg, #ffffff 0%, #f8f8f8 100%);
  color: #ff9a9e;
  border: none;
}

.ios-btn {
  background: rgba(255, 255, 255, 0.85);
  color: #ff9a9e;
  border: none;
}

/* 数据统计区域 */
.stats-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
  padding: 30px 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  animation: fadeInUp 1s ease-out 1.2s both;
}

.stat-item {
  text-align: center;
  padding: 0 30px;
}

.stat-number {
  font-size: 36px;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.stat-label {
  font-size: 14px;
  color: #ffffff;
  margin-top: 5px;
  opacity: 0.9;
}

.stat-divider {
  width: 1px;
  height: 40px;
  background: rgba(255, 255, 255, 0.5);
}

/* 功能特点区域 */
.features-section {
  padding: 100px 0;
  background: linear-gradient(180deg, #ffffff 0%, #fff9f9 100%);
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 36px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 15px;
}

.section-subtitle {
  font-size: 18px;
  color: #666666;
}

.features-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.feature-item {
  background: #ffffff;
  border-radius: 20px;
  padding: 30px 20px;
  transition: all 0.4s ease;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.feature-item:hover {
  transform: translateY(-15px);
  box-shadow: 0 20px 40px rgba(255, 154, 158, 0.2);
}

.feature-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.feature-title {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 10px;
}

.feature-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.feature-image {
  width: 100%;
  height: auto;
  border-radius: 10px;
  transition: transform 0.3s ease;
}

.feature-item:hover .feature-image {
  transform: scale(1.05);
}

/* 用户评价区域 */
.testimonials-section {
  padding: 100px 0;
  background: linear-gradient(180deg, #fff9f9 0%, #ffffff 100%);
}

.testimonials-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.testimonial-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.testimonial-card:hover {
  transform: translateY(-10px);
  border-color: #ff9a9e;
  box-shadow: 0 20px 50px rgba(255, 154, 158, 0.15);
}

.testimonial-avatar {
  font-size: 60px;
  margin-bottom: 15px;
}

.testimonial-name {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 5px;
}

.testimonial-location {
  font-size: 14px;
  color: #999999;
  margin-bottom: 15px;
}

.testimonial-text {
  font-size: 16px;
  color: #666666;
  line-height: 1.8;
  font-style: italic;
  margin-bottom: 15px;
}

.testimonial-rating {
  color: #ffc107;
  font-size: 18px;
}

/* 底部CTA区域 */
.cta-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%);
  text-align: center;
}

.cta-title {
  font-size: 36px;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 15px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.cta-subtitle {
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 40px;
  opacity: 0.95;
}

.cta-buttons {
  display: flex;
  justify-content: center;
}

.cta-section .download-btn {
  background: #ffffff;
  color: #ff9a9e;
}

.cta-section .ios-btn {
  background: rgba(255, 255, 255, 0.85);
}

/* 页脚 */
.footer {
  background-color: #333333;
  color: #ffffff;
  padding: 40px 0;
  text-align: center;
}

.footer-content {
  max-width: 1000px;
  margin: 0 auto;
}

.footer-link {
  color: #ff9a9e;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #fecfef;
  text-decoration: underline;
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .top_style1 {
    padding: 0 5%;
    height: 60px;
  }

  .logo {
    font-size: 18px;
  }

  .logo img {
    width: 30px;
  }

  .nav-link {
    margin-left: 15px;
    font-size: 14px;
  }

  .hero-section {
    min-height: 500px;
  }

  .hero-content {
    padding: 40px 15px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .hero-image {
    max-width: 100%;
    border-radius: 15px;
  }

  .download-buttons {
    flex-direction: column;
    align-items: center;
  }

  .download-btn {
    margin: 10px 0;
    width: 200px;
  }

  .stats-section {
    flex-direction: column;
    padding: 20px;
  }

  .stat-item {
    padding: 15px 0;
  }

  .stat-number {
    font-size: 24px;
  }

  .stat-divider {
    width: 60px;
    height: 1px;
    margin: 10px 0;
  }

  .section-title {
    font-size: 24px;
  }

  .section-subtitle {
    font-size: 14px;
  }

  .features-container,
  .testimonials-container {
    padding: 0 15px;
  }

  .el-row {
    flex-direction: column;
  }

  .el-col {
    width: 100%;
    margin-bottom: 30px;
  }

  .feature-item {
    padding: 20px 15px;
  }

  .feature-icon {
    font-size: 36px;
  }

  .feature-title {
    font-size: 18px;
  }

  .feature-desc {
    font-size: 13px;
  }

  .testimonial-card {
    padding: 30px 20px;
  }

  .testimonial-avatar {
    font-size: 48px;
  }

  .testimonial-name {
    font-size: 18px;
  }

  .testimonial-text {
    font-size: 14px;
  }

  .cta-title {
    font-size: 24px;
  }

  .cta-subtitle {
    font-size: 14px;
  }

  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }

  .features-section,
  .testimonials-section,
  .cta-section {
    padding: 60px 0;
  }
}
</style>
